import LongText from '@components/long-text/long-text';
import styled from '@emotion/styled';
import vars from '@variables';
import { CtaProps } from './homepage-masthead.types';
import { H1Atom } from '@atoms/text-atoms/text-atoms';
import { LetterboxLinkAtom } from '@atoms/link-atoms/link-atoms';

export const HomepageMastheadContainer = styled.div<{
  backgroundColour?: string;
  enableLightText?: boolean;
  cta: CtaProps;
}>`
  --homepage-masthead-height: 100vh;

  position: relative;
  min-height: 600px;
  clip-path: inset(0);

  background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 70%);
  background-color: ${({ backgroundColour }) =>
    backgroundColour ? backgroundColour : vars.coreDarkGrey};

  .content-frame {
    width: 100%;
    max-width: ${vars.mainMaxWidth};
    margin: auto;
    z-index: 30;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    top: 50%;
    transform: translateY(65%);
    padding-left: 4%;
    padding-right: 4%;

    @media screen and (min-width: ${vars.breakPointTablet}) {
      padding: 0;
      height: calc(var(--homepage-masthead-height));
      top: 0;
      transform: translateY(0);
    }

    .text-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: left;
      max-width: ${process.env.GATSBY_IS_COP === 'true' ? 45 : 65}rem;
      padding-left: 0;

      @media screen and (min-width: ${vars.breakPointTablet}) {
        padding-left: ${vars.spacingL};
      }

      ${H1Atom} {
        font-weight: ${vars.fontWeightBold};
        padding: 0;
        margin-bottom: ${vars.spacingL};
        font-size: 4rem;
        line-height: 95%;
        color: ${({ enableLightText }) =>
          enableLightText ? vars.white : vars.coreDarkGrey};

        @media screen and (min-width: ${vars.breakPointTablet}) {
          font-size: 7rem;
        }
      }
      ${LongText} {
        margin-bottom: ${vars.spacingM};
        max-width: 32rem;
        p {
          padding: 0;
          line-height: 130%;
          margin-bottom: ${vars.spacingM};
          color: ${({ enableLightText }) =>
            enableLightText ? vars.white : vars.coreDarkGrey};
          font-weight: ${vars.fontWeightRegular};
          ${vars.fontSize4}
        }

        @media screen and (min-width: ${vars.breakPointTenColumn}) {
          max-width: 38rem;
        }

        @media screen and (min-width: ${vars.breakPointTablet}) {
          max-width: 48rem;
        }
      }
      ${LetterboxLinkAtom} {
        display: flex;
        justify-content: center;
        align-items: center;
        align-self: flex-start;
        border-radius: 4px;
        color: ${vars.white};
        background-color: transparent;
        border: 1px solid ${vars.white};
        height: 64px;
        width: 280px;

        &:hover {
          color: ${({ cta }) =>
            cta.enableLightText ? vars.coreDarkGrey : vars.white};
          background-color: ${({ cta }) =>
            cta.enableLightText
              ? vars.white
              : cta.backgroundColour || vars.coreDarkGrey};
        }
      }
    }
  }

  .background-image {
    position: fixed;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    @media screen and (min-width: ${vars.breakPointTablet}) {
      height: var(--homepage-masthead-height);
    }

    > .masthead-gif {
      width: 100%;
    }
  }

  .art-directed {
    width: 100%;
    height: 100vh;
  }

  .icon-scroll,
  .icon-scroll:before {
    display: none;
  }

  @media screen and (min-width: ${vars.breakPointTenColumn}) {
    .art-directed {
      top: 0rem;
    }
  }

  @media screen and (min-width: ${vars.breakPointTablet}) {
    .icon-scroll,
    .icon-scroll:before {
      display: block;
      position: absolute;
      left: 50%;
    }

    .icon-scroll {
      width: 30px;
      height: 53px;
      margin-left: -20px;
      top: 90%;
      margin-top: -35px;
      box-shadow: inset 0 0 0 1px #fff;
      border-radius: 25px;
      z-index: 500;
      transition: 0.2s ease-in;
    }

    .icon-scroll:before {
      content: '';
      width: 6px;
      height: 6px;
      background: #fff;
      margin-left: -3px;
      top: 8px;
      border-radius: 4px;
      animation-duration: 1.5s;
      animation-iteration-count: infinite;
      animation-name: scroll;
    }

    @keyframes scroll {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
        transform: translateY(46px);
      }
    }
  }
`;
